"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTextInput = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const React = __importStar(require("react"));
const text_field_clean_wrapper_1 = require("../text-field-clean-wrapper");
const text_field_wrapper_1 = require("../text-field-wrapper");
const utils_1 = require("../utils");
const text_helpers_1 = require("../../helpers/text-helpers");
// @todo get from theme
const borderSize = '1px';
const StyledInput = components_core_1.styled.input `
  height: 100%;
  min-height: ${(props) => props.theme.size.static300};
  width: 100%;
  padding: ${(props) => props.icon
    ? `${props.theme.size.static150} ${props.theme.size.static400}`
    : props.rightIcon
        ? `${props.theme.size.static150} ${props.theme.size.static400} ${props.theme.size.static150} 5px`
        : `${props.theme.size.static150} 0`};
  border: 0;
  border-bottom: ${props => props.hideBorderBottom
    ? 'none'
    : ({ appearance }) => appearance !== text_helpers_1.TextInputAppearance.ReadOnly && `${borderSize} solid`};
  border-color: ${(props) => {
    // let color: string | undefined = props.theme.interaction.recipe150.default;
    let color = '#001E50';
    if (props.appearance === text_helpers_1.TextInputAppearance.Error) {
        color = props.theme.colors.signal.error;
    }
    else if (props.appearance === text_helpers_1.TextInputAppearance.Success) {
        color = props.theme.colors.signal.success;
    }
    return color;
}};
  border-radius: 0;
  background: transparent;
  cursor: ${(props) => props.appearance === text_helpers_1.TextInputAppearance.Disabled ? 'not-allowed' : ''};

  color: ${(props) => props.customTextColor ? props.customTextColor : utils_1.getColor};
  outline: 0;
  ${(props) => props.useCustomZipText &&
    `font-size:${props.fontSize ? props.fontSize : '20px'};
    line-height: 36px;
    font-family: 'vw-head', Helvetica, Arial, sans-serif;
    font-weight: 300;
    @media (min-width: ${components_core_1.Breakpoints.b960}px) {
      font-size: 32px;
    }
  `}



  margin: ${(props) => props.theme.size.static100} 0;

  &:focus {
    border-color: ${(props) => {
    if (props.appearance === text_helpers_1.TextInputAppearance.Error ||
        props.appearance === text_helpers_1.TextInputAppearance.Success) {
        return;
    }
    return props.theme.colors.border.active;
}};
    outline-style: solid;
    outline-width: 1px;
    outline-color: ${(props) => props.theme.colors.border.default};
    outline-offset: 2px;
  }
  &::-ms-clear {
    display: none;
  }
`;
/* eslint-disable-next-line react/display-name */
exports.CustomTextInput = React.forwardRef(props => {
    const { additionalFeedback, appearance, errorText, required = false, icon, rightIcon, rightIconColor, rightIconBtnFun, onClear, hasClearButton, isClearButtonVisible, clearIconLabel = '', label = '', useCustomZipText = false, value, ariaLabel } = props;
    return (React.createElement(text_field_wrapper_1.TextFieldWrapper, { appearance: appearance, label: label, useCustomZipText: useCustomZipText, errorText: errorText, value: value, required: required, icon: icon, rightIcon: rightIcon, rightIconColor: rightIconColor, rightIconBtnFun: rightIconBtnFun, additionalFeedback: additionalFeedback, ariaLabel: ariaLabel },
        React.createElement(text_field_clean_wrapper_1.TextFieldCleanWrapper, { onClear: onClear, hasClearButton: hasClearButton, isClearButtonVisible: isClearButtonVisible, clearIconLabel: clearIconLabel },
            React.createElement(StyledInput, Object.assign({}, props, { disabled: appearance === text_helpers_1.TextInputAppearance.Disabled, readOnly: appearance === text_helpers_1.TextInputAppearance.ReadOnly, className: "input-text-field" })))));
});
